import { useEffect, useRef } from 'react';

/**
 * A hook that automatically scrolls an element into view when activated
 * @param isActive - Boolean flag indicating whether the element should be scrolled into view
 * @returns A ref object that should be attached to the target element
 * @template T - The type of HTML element to attach the ref to
 * @example
 * const ref = useAutoScrollIntoView<HTMLDivElement>(isActive);
 * return <div ref={ref}>Content</div>
 */
export function useAutoScrollIntoView<T extends HTMLElement>(
  isActive: boolean,
) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (isActive && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [isActive]);

  return ref;
}
